module.exports = __webpack_public_path__ + "static/media/JumboFeat.a8de7eab.png";